import { variables } from '../common/variables';

import { cl } from '../common/functions';

import { makeMarkerIcon } from './leaflet/markerIcon';

let geolocation = (map, group) => {
  let leafletControlContainer = document.querySelector('.leaflet-top.leaflet-left');
  if (leafletControlContainer !== null) {
    let geolocationElement = `<div class="leaflet-control-geolocation leaflet-bar leaflet-control">
    <a class="leaflet-control-geolocation-button leaflet-bar-part"></a>
    </div>`;
    leafletControlContainer.insertAdjacentHTML('beforeend', geolocationElement);
    let geolocationButton = document.querySelector('.leaflet-control-geolocation-button');
    if (geolocationButton !== null) {
      // prettier-ignore
      geolocationButton.addEventListener('click', () => {
        //geolocalisation
        navigator.geolocation.getCurrentPosition(location => {
          // cl(location);
          let marker = L.marker([location.coords.latitude, location.coords.longitude], {
            icon: makeMarkerIcon(null, type, "#42ace8", "user", null)
          });
          marker.addTo(map);
          marker.addTo(group);
          map.fitBounds(group.getBounds().pad(0));
        });
      }, false);
    }
  }
};

export { geolocation };
